import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@hokm/shared';
import { RENDER_SCALE } from '../../../config';

/**
 * Visual representation of the deck in the center of the table.
 * Shows stacked card backs that deplete as cards are drawn.
 */
export class DeckVisual {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.container = this.create();
  }

  private create(): Phaser.GameObjects.Container {
    const container = this.scene.add.container(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 30);
    container.setDepth(2);

    // Create stacked card backs to look like a deck
    const stackCount = 8;
    for (let i = 0; i < stackCount; i++) {
      const cardBack = this.scene.add.image(i * 0.5, -i * 0.5, 'card-back');
      cardBack.setScale(0.5 / RENDER_SCALE);
      container.add(cardBack);
    }

    container.setVisible(false);
    return container;
  }

  /**
   * Update the deck visual based on remaining cards.
   */
  update(cardsRemaining: number): void {
    const children = this.container.getAll() as Phaser.GameObjects.Image[];
    const maxCards = 52;
    const stackCount = children.length;
    const cardsPerStack = maxCards / stackCount;

    children.forEach((card, i) => {
      const threshold = maxCards - (i + 1) * cardsPerStack;
      card.setVisible(cardsRemaining > threshold);
    });

    if (cardsRemaining <= 0) {
      this.container.setVisible(false);
    }
  }

  setVisible(visible: boolean): void {
    this.container.setVisible(visible);
  }

  getContainer(): Phaser.GameObjects.Container {
    return this.container;
  }

  destroy(): void {
    this.container.destroy();
  }
}
